<template>
  <div v-if="!privacyStore.hideCustomerMappings && (canSeeCustomerMappings || mappingStore.items.length > 0)" class="flex flex-wrap items-center gap-2 text-xs text-gray-600" aria-label="Customer color legend">
    <span
      v-for="mapping in mappingStore.items"
      :key="mapping.id"
      class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2 py-0.5"
    >
      <span class="inline-block h-2.5 w-2.5 rounded-full" :style="{ backgroundColor: mapping.color }" />
      {{ customerLabel(mapping) }}
    </span>
    <span class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2 py-0.5">
      <span class="inline-block h-2.5 w-2.5 rounded-full" :style="{ backgroundColor: UNMAPPED_PO_COLOR }" />
      Unmapped
    </span>
    <router-link v-if="canSeeCustomerMappings" class="text-blue-700 hover:underline" :to="{ name: 'CustomerMappingList' }">Edit mappings</router-link>
  </div>
</template>

<script setup lang="ts">
  import { useAccess } from '@/composables/useAccess';
  import { useCalendarPrivacyStore } from '@/store/calendarPrivacyStore';
  import { useCustomerMappingStore } from '@/store/customerMappingStore';
  import { customerLabel, UNMAPPED_PO_COLOR } from '@/utils/customerColors';

  // Partners see "Customer B" placeholders (the API redacts names for them); privacy mode
  // hides the legend outright because it would still map colours back to customers.
  const mappingStore = useCustomerMappingStore();
  const privacyStore = useCalendarPrivacyStore();
  const { canSeeCustomerMappings } = useAccess();
</script>
